module.exports = __webpack_public_path__ + "img/f_b2_stardusttiara.72e01fb6.jpg";